/**
 * Simple API class service for making Axios calls
 * and returning a promise for each call
 */
import CustomStore          from 'devextreme/data/custom_store';
import axios from 'axios';
import 'lodash';

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] ='application/json';
// axios.defaults.withCredentials = true;

class Api {

    constructor() {
        this.base_url = this.getBaseUrl();
    }

    getBaseUrl() {
        let baseUrl = `${process.env.VUE_APP_API_BASE_URL}/api`;
        return baseUrl;
    }

    /**
     * Get
     * @param {string} endpoint
     * @param {*} params
     */
    get(endpoint, params = {}, headers = {}, responseType = 'json' ) {
        let config = {
            url: `${this.base_url}/${endpoint}`,
            params: params,
            method: 'GET',
            responseType: responseType,
        };

        if (!_.isEmpty(headers)){
            config['headers'] = headers;
        }

        return new Promise((resolve, reject) => {
            axios(config).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }

    /**
     * Get
     * @param {string} endpoint
     * @param {*} params
     */
    getFullUrl(endpoint, params = {}, headers = {}) {
        let config = {
            url: `${endpoint}`,
            params: params,
            method: 'GET',
        };

        if (!_.isEmpty(headers)){
            config['headers'] = headers;
        }

        return new Promise((resolve, reject) => {
            let axiosInstance = axios.create(); // why create an instance you might ask?? bc it lets me delete the Auth Bearer header without affecting all the other requests (was throwing error when accessing azure blob storage)
            delete axiosInstance.defaults.headers.common['Authorization'];
            axiosInstance(config).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }

    /**
     * Get
     * @param {string} endpoint
     * @param {*} params
     */

     // For some reason this does not support .then()
    getDataSource(endpoint, dataSourceKey = 'Id', parameters = {}, headers = {}, responseType = 'json' ){
        // console.log('do we get to api get ds')
        let url = `${this.base_url}/${endpoint}`
        function isNotEmpty(value) {
            return value !== undefined && value !== null && value !== '';
        }

        let keys = Object.keys(parameters)
        let parameterString = '?'
        keys.forEach((key, index) => {
            parameterString += index ? `&${key}=${parameters[key]}` : `${key}=${parameters[key]}`
        })
        parameterString += '&'
        // let source = axios.CancelToken.source();
        
        // source && source.cancel('request canceled')  
        // let cancelToken = source.token
        return  new CustomStore({
            key: dataSourceKey,
            // loadMode: 'raw',
            // cacheRawData: true,
            load: function(loadOptions) {
                // console.log(loadOptions)
                // let params = '?';
                let params = parameterString;
                [
                'skip',
                'take',
                'requireTotalCount',
                'requireGroupCount',
                'sort',
                'filter',
                'totalSummary',
                'group',
                'groupSummary'
                ].forEach(function(i) {
                if(i in loadOptions && isNotEmpty(loadOptions[i]))
                { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
                });
                params = params.slice(0, -1);
                
                let config = {
                    url: `${url}${params}`,
                    isDataSourceRequest: true,
                    // cancelTokenSource: source,
                    // cancelToken: cancelToken,
                    // params: params,
                    method: 'GET',
                    responseType: responseType,
                    
                };

                if (!_.isEmpty(headers)){
                    config['headers'] = headers;
                }

                return new Promise((resolve, reject) => {
                    axios(config).then(res => {
                        // console.log('get dataSource', res.data)
                        resolve(res.data);
                    }).catch(err => {
                        reject(err);
                    });
                });
            }
        });
    }

    /**
     * Post
     * @param {string} endpoint
     * @param {*} data
     */
    post(endpoint, data = {}, headers = {}) {
        let config = {
            url: `${this.base_url}/${endpoint}`,
            data: data,
            method: 'POST',      
        };
        if (!_.isEmpty(headers)){
            config['headers'] = headers;
        }
        return new Promise((resolve, reject) => {
            axios(config).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }

    /**
     * PUT
     * @param {string} endpoint
     * @param {*} data
     */
    put(endpoint, data = {}) {
        return new Promise((resolve, reject) => {
            axios({url:`${this.base_url}/${endpoint}`, data: data, method: 'PUT'}).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }

    /**
     * Delete
     * @param {string} endpoint
     * @param {*} params
     */
    delete(endpoint, params = {}) {
        return new Promise((resolve, reject) => {
            axios({url: `${this.base_url}/${endpoint}`, params, method: 'DELETE' }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export default new Api;
